import { render, staticRenderFns } from "./ProductEditItem.vue?vue&type=template&id=108e4069&scoped=true&"
import script from "./ProductEditItem.vue?vue&type=script&lang=js&"
export * from "./ProductEditItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditItem.vue?vue&type=style&index=0&id=108e4069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e4069",
  null
  
)

export default component.exports